/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Accountsettings_Revokesession2Inputs */

const zh_accountsettings_revokesession2 = /** @type {(inputs: Accountsettings_Revokesession2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`注销会话`)
};

const en_accountsettings_revokesession2 = /** @type {(inputs: Accountsettings_Revokesession2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revoke Session`)
};

const es_accountsettings_revokesession2 = /** @type {(inputs: Accountsettings_Revokesession2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revocar sesión`)
};

/**
* | output |
* | --- |
* | "Revoke Session" |
*
* @param {Accountsettings_Revokesession2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const accountsettings_revokesession2 = /** @type {((inputs?: Accountsettings_Revokesession2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Accountsettings_Revokesession2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_accountsettings_revokesession2(inputs)
	if (locale === "en") return en_accountsettings_revokesession2(inputs)
	return es_accountsettings_revokesession2(inputs)
});
export { accountsettings_revokesession2 as "accountSettings_revokeSession" }